import Vue from 'vue'
import Router from 'vue-router'
import Overview from '@/components/Overview'
import Login from '@/components/Login'
import Register from '@/components/Register'
import VerifyEmail from '@/components/VerifyEmail'
import RecoverPassword from '@/components/RecoverPassword'
import ResetPassword from '@/components/ResetPassword'

import store from '../store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/login/register',
      name: 'Register',
      component: Register,
      meta: {
        title: 'Register an account'
      }
    },
    {
      path: '/login/verify/:email/:token',
      name: 'Verify Email',
      component: VerifyEmail,
      meta: {
        title: 'Verify Email'
      }
    },
    {
      path: '/login/forgot-password',
      name: 'Recover Password',
      component: RecoverPassword,
      meta: {
        title: 'Recover your Password'
      }
    },
    {
      path: '/login/reset-password/:email/:token',
      name: 'Reset Password',
      component: ResetPassword,
      meta: {
        title: 'Reset your Password'
      }
    },
    {
      path: '/',
      name: 'Overview',
      component: Overview,
      meta: {
        title: 'Excel to ecoSpold2 Web Converter',
        requiresAuthentication: true
      }
    },
    {
      path: '*',
      name: '404: Not Found',
      component: Overview,
      meta: {
        requiresAuthentication: true
      }
    }
  ],
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = 'ecoinvent - ' + to.meta.title
  }
  if (to.matched.some(record => record.meta.requiresAuthentication)) {
    // this route requires authentication, check if logged in
    // if not, redirect to login page.
    if (!store.state.isAuthenticated) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js